import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { LoginRequiredState } from '@/features/auth/components/LoginRequiredState'
import { ensureFreshAccessToken, hasUsableAuthSession } from '@/api/authSession'
import { useAuth } from '@/hooks'

interface RequireAuthProps {
  children: React.ReactNode
  /** 未登录时跳转登录页并带上此 redirect */
  redirectTo?: string
}

/** 需登录:未登录或会话失效时重定向到登录页 */
export function RequireAuth({ children, redirectTo }: RequireAuthProps) {
  const location = useLocation()
  const { isAuthenticated } = useAuth()

  useEffect(() => {
    if (!isAuthenticated) return
    void ensureFreshAccessToken()
  }, [isAuthenticated])

  if (!isAuthenticated) {
    const redirectTarget =
      redirectTo ?? `${location.pathname}${location.search}`
    return <LoginRequiredState redirectTo={redirectTarget} />
  }

  return <>{children}</>
}

/** 应用启动时若已有会话,定期续签即将过期的 access token */
export function AuthSessionBootstrap() {
  const { isAuthenticated } = useAuth()

  useEffect(() => {
    if (!isAuthenticated || !hasUsableAuthSession()) return

    void ensureFreshAccessToken()

    const timer = window.setInterval(() => {
      if (hasUsableAuthSession()) {
        void ensureFreshAccessToken()
      }
    }, 60_000)

    return () => window.clearInterval(timer)
  }, [isAuthenticated])

  return null
}
